import { ObjectMapper } from "json-object-mapper";

export class ComptimeEmployeeBalanceModel {
  foreignId: string = "";
  registration: string = "";
  balance: number = 0;
  asOfDate: string = "";

  static create(input: any): ComptimeEmployeeBalanceModel {
    return ObjectMapper.deserialize<ComptimeEmployeeBalanceModel>(
      ComptimeEmployeeBalanceModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
